import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { semanticColors, greyScaleColors } from '../../Globals/styles';

class Booking extends Component {
  render() {
    const { workplace, openEditBookingModal, goToDagrapport, isCompressed } = this.props;
    let workedHere = workplace.hours > 0 || workplace.absent;
    let scheduled = !workplace.hours && !workplace.absent;

    let slash = workplace.absent && workplace.hours > 0 ? ' / ' : '';
    let absentText = workplace.absent ? 'Fravær' : '';
    let hourText = workplace.hours > 0 ? workplace.hours : '';
    return (
      isCompressed ?
        <div className="waves-btn" style={[styles.workplace, workedHere && styles.workedHere, styles.isCompressed, workplace.invoiced && styles.isInvoiced]}>
          <div style={styles.ellipsis} onClick={goToDagrapport}>
            {workplace.name}
          </div>
        </div>
        :
        <div className="waves-btn" style={[styles.workplace, workedHere && styles.workedHere, workplace.invoiced && styles.isInvoiced]}>
          {workedHere ?
            <div style={styles.completedCardheadder}>
              <p style={styles.registreret}>Registreret</p>
              <b style={styles.hours}>{hourText}{slash}{absentText}</b>
            </div>

            :
            <i className="fa fa-pencil waves-icon"
              aria-hidden="true"
              onClick={openEditBookingModal}
              style={styles.editIcon} />
          }
          <div onClick={goToDagrapport}>
            <div style={styles.paddingBottom}>
              {scheduled ?
                <span>{workplace.startTime}:00 - {workplace.endTime}:00 </span> :
                null
              }
            </div>
            <div style={[styles.borderBottom, styles.paddingBottom, scheduled ? styles.lessPadding : null]}>
              <div style={styles.ellipsis}>{workplace.project.number}</div>
              <div style={styles.ellipsis}>{workplace.project.name}</div>
            </div>
            <div style={[styles.paddingBottom, styles.paddingTop, styles.ellipsis]}>{workplace.name}</div>
            <div style={[styles.paddingBottom]}>
              <div style={styles.ellipsis}>{workplace.client.name}</div>
              <div style={styles.ellipsis}>{workplace.client.contact.name}</div>
            </div>
          </div>
        </div>
    );
  }
}

var styles = {
  workplace: {
    backgroundColor: greyScaleColors.greyLighter,
    marginBottom: '10px',
    cursor: 'pointer',
    padding: '5px 10px',
    height: '150px',
    fontSize: '12px',
    borderRadius: '2px',
    textAlign: 'center',
    position: 'relative',
    display: 'block',
    lineHeight: 'initial'
  },
  borderBottom: {
    borderBottom: '1px solid ' + semanticColors.mainBackground
  },
  paddingBottom: {
    paddingBottom: '10px'
  },
  paddingTop: {
    paddingTop: '5px'
  },
  editIcon: {
    position: 'absolute',
    right: '0px',
    top: '0px',
    fontSize: '18px',
    width: '30px',
    height: '30px',
    lineHeight: '30px',
    cursor: 'pointer'
  },
  workedHere: {
    backgroundColor: semanticColors.primaryLight
  },
  hours: {
    position: 'absolute',
    right: '10px',
    fontSize: '12px'
  },
  registreret: {
    position: 'absolute',
    left: '10px',
    fontSize: '12px'
  },
  isCompressed: {
    height: '25px'
  },
  completedCardheadder: {
    height: '20px',
    borderBottom: '1px solid' + semanticColors.mainBackground
  },
  lessPadding: {
    paddingBottom: '5px'
  },
  ellipsis: {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden'
  },
  isInvoiced: {
    backgroundColor: semanticColors.successLight
  }
}
Booking.propTypes = {
  workplace: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    client: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      contact: PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired
      }).isRequired
    }).isRequired,
    employees: PropTypes.object,
    project: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      number: PropTypes.string.isRequired
    }).isRequired,
    startTime: PropTypes.number.isRequired,
    endTime: PropTypes.number.isRequired,
    hours: PropTypes.number,
    absent: PropTypes.bool
  }),
  openEditBookingModal: PropTypes.func.isRequired,
  goToDagrapport: PropTypes.func.isRequired,
  isCompressed: PropTypes.bool.isRequired
};
export default Radium(Booking)


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/EmployeeWeekOverview/booking.jsx